/*
 * O chunk do painel do menu de busca (SearchPanel + motor da busca). O campo
 * do cabeçalho está no pacote principal; o painel desce no ocioso do boot, no
 * hover/toque/foco do campo, ou quando o painel abre — o que vier primeiro.
 */
import Component from 'flarum/common/Component';
import { once } from '../utils/chunkGate';
let loaded = null;
const load = once(() => import(/* webpackChunkName: 'forum/search/SearchPanel', webpackMode: 'lazy-once' */ './SearchPanel').then(panel => {
  loaded = panel;
  return panel;
}));
let idleQueued = false;

/** `idle`: espera o navegador ficar ocioso (fora da primeira pintura); senão, já. */
export function preloadSearchPanel(opts) {
  if (loaded) return;
  if (opts && !(opts instanceof Event) && opts.idle) {
    if (idleQueued) return;
    idleQueued = true;
    const run = () => load().catch(() => {});
    const idle = window.requestIdleCallback;
    if (idle) idle(run, {
      timeout: 4000
    });else window.setTimeout(run, 2000);
    return;
  }
  load().catch(() => {});
}

/** Roda já se o chunk chegou (sem perder o redesenho do evento); senão, quando chegar. */
export function withSearchPanel(run) {
  if (loaded) {
    run(loaded);
    return;
  }
  load().then(panel => {
    run(panel);
    m.redraw();
  }).catch(() => {});
}
/** O painel, se o chunk já chegou; senão nada até ele chegar (normalmente já chegou). */
export class SearchPanelSlot extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    if (!loaded) load().then(() => m.redraw(), () => {});
  }
  view() {
    const Panel = loaded?.default;
    return Panel ? m(Panel, {
      menu: this.attrs.menu
    }) : null;
  }
}
flarum.reg.add('ramon-canela', 'forum/search/panelLazy', { preloadSearchPanel: preloadSearchPanel,withSearchPanel: withSearchPanel,SearchPanelSlot: SearchPanelSlot, });flarum.reg.addChunkModule('forum/search/SearchPanel', './src/forum/search/SearchPanel.tsx', 'ramon-canela', 'forum/search/SearchPanel');
flarum.reg.addChunkModule('forum/search/SearchPanel', './src/forum/search/SearchPanel.tsx', 'ramon-canela', 'forum/search/assist');
flarum.reg.addChunkModule('forum/search/SearchPanel', './src/forum/search/SearchPanel.tsx', 'ramon-canela', 'forum/search/engine');